export const fieldNameSorter = (a: { name: string }, b: { name: string }) => {
  return a.name.localeCompare(b.name, undefined, { numeric: true });
};
